module.exports = __webpack_public_path__ + "media/packs/images/remarks-focus-ece3df6e772a35e4b305260e5e1f03e1.svg";